import HeaderBar from "../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import "../../assets/styles/admin/booking.scss";


const Booking = () => {

  const history = useHistory();

  return (
    <div>
      <HeaderBar title="BOOKING" />
      <div style={{ marginTop: "20px", padding: "0px 40px" }}>
        <h5>เลือกสาขา</h5>
      </div>
      <div style={{ marginTop: "40px", padding: "0px 40px" }}>
        <div style={{display:"flex",cursor:"pointer"}}>
          <div className="booking-view-card" onClick={() => history.push(`/booking/list/ADIS0701/view`)}>
            <div className="booking-container">
              <div className={'booking-header'}>

              </div>
              <div className={'booking-row'} style={{ padding: "10px 20px", textAlign: "center",marginTop:"10px"}}>
                <h5>เอกมัย</h5>
              </div>
            </div>
          </div>
          <div className="booking-view-card">
            <div className="booking-container">
              <div className={'booking-header'}>

              </div>
              <div className="booking-row" style={{ padding: "10px 20px", textAlign: "center",marginTop:"10px"}}>
                <h5>พระราม 9</h5>
              </div>
            </div>
          </div>
          <div className="booking-view-card">
            <div className="booking-container">
              <div className={'booking-header'}>

              </div>
              <div className="booking-row" style={{ padding: "10px 20px", textAlign: "center",marginTop:"10px"}}>
                <h5>ชิดลม</h5>
              </div>
            </div>
          </div>
          <div className="booking-view-card">
            <div className="booking-container">
              <div className={'booking-header'}>

              </div>
              <div className="booking-row" style={{ padding: "10px 20px", textAlign: "center",marginTop:"10px"}}>
                <h5>สาทร</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Booking;
